import ReactPixel from 'react-facebook-pixel';
import { ItemPriceType } from '@lemonadefashion/item';
import { OrderPriceType } from '@lemonadefashion/order';
import { isEmployeeAndOptedOut, optOutEmployee } from './employee_opt_out';
import { isDNTEnabled } from './dnt';
import { getQueryParam } from '../utils/query_string';

const ADD_TO_CART_MULTIPLIER = 0.02;
const VIEW_CONTENT_MULTIPLIER = 0.001;

// webview mode
const minimal = new URLSearchParams(window.location.search).get('minimal');

export function initializeFacebookPixel() {
  if (minimal === 'true') return;
  if (process.env.REACT_APP_FB_PIXEL_ENABLED !== 'true' || isDNTEnabled()) {
    console.log('Facebook Pixel blocked.');
    return;
  }
  if (isEmployeeAndOptedOut()) {
    console.log('Employee opted out.');
    return;
  } else if (getQueryParam(window.location.search, 'employee_opt_out') === '324987') {
    optOutEmployee();
    console.log('Employee opted out.');
    return;
  }
  const advancedMatching = {};
  const options = { autoConfig: true, debug: false };
  ReactPixel.init(process.env.REACT_APP_FB_PIXEL_ID, advancedMatching, options);
}

const isCustomEventName = (eventName) => {
  // This function must be updated to take into account all non-custom events.
  if (eventName === 'Purchase') return false;
  if (eventName === 'AddToCart') return false;
  if (eventName === 'ViewContent') return false;
  return true;
};

function pixelTrack(eventName, payload) {
  if (process.env.REACT_APP_FB_PIXEL_ENABLED !== 'true') return;
  if (isDNTEnabled()) return;
  if (isEmployeeAndOptedOut()) return;
  if (isCustomEventName(eventName)) {
    ReactPixel.trackCustom(eventName, payload);
  } else {
    ReactPixel.track(eventName, payload);
  }
}

export function pixelTrackTruePageView(fullRoute) {
  pixelTrack('TruePageView', { url: fullRoute });
}

export function pixelTrackViewContent(item) {
  const value = item.getDefaultPrimaryPrice(ItemPriceType.SHIPPING_COMPENSATED_PROMO_PRICE);
  pixelTrack('ViewContent', {
    value: value.amount * VIEW_CONTENT_MULTIPLIER,
    currency: value.currency,
    content_ids: [item.getId()],
    content_type: 'product',
    content_name: item.getName(),
    contents: [{
      id: item.getId(),
      item_price: value.amount,
      quantity: 1
    }]
  });
}

export function pixelTrackAddItemToCart(item, price) {
  const value = price.amount * ADD_TO_CART_MULTIPLIER;
  const currency = price.currency;
  pixelTrack('AddToCart', {
    content_name: item.getName(),
    content_ids: [item.getId()],
    content_type: 'product',
    currency: currency,
    value: value,
    contents: [{
      id: item.getId(),
      item_price: value,
      quantity: 1
    }]
  });
}

export function pixelTrackPurchase(cart) {
  const pricing = cart.getPricing({ useEphemeral: true });
  const orderPrice = pricing.getPrimaryPrice(OrderPriceType.POST_CREDIT_TOTAL);
  const orderAmount = orderPrice.amount;
  const orderCurrency = orderPrice.currency;
  pixelTrack('Purchase', {
    value: orderAmount,
    currency: orderCurrency,
    content_type: 'product',
    /* This is probably best retrieved as part of the order placement response */
    content_ids: cart.all({ useEphemeral: true }).map(element => element.getContentId()),
    contents: cart.all({ useEphemeral: true }).map(element => ({
      id: element.getContentId(),
      quantity: element.getQuantity(),
      item_price: element.getFinalUnitPrimaryPrice().amount
    }))
  });
}
